import { css } from "@emotion/react";
import styled from "@emotion/styled";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontMerriweather, fontRoboto, theme as mediaTheme } from "shared/lib/styles";

import { SignUpButton } from "./sign-up-button";

export const StyledSignUpButton = styled(SignUpButton)``;

export const AgreementCheckboxContainer = styled.div`
  cursor: pointer;
`;

export const AgreementDescription = styled.div`
  max-inline-size: 254px;
  margin-inline-end: 8px;

  color: #666666;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 13px;
`;

type AgreementContainerProps = {
  theme?: ThemeType;
};
export const AgreementContainer = styled.div<AgreementContainerProps>`
  grid-area: Agreement;

  display: flex;

  margin-block-end: 12px;

  ${mediaTheme.breakpoints.up("tablet")} {
    margin-block-end: ${props => (props.theme?.orientation === "landscape" ? "0" : "12px")};
  }

  :empty {
    margin-block-end: 0;
  }
`;

export const DescriptionContainer = styled.div`
  grid-area: Description;

  margin-block: 4px 10px;
`;

export const Description = styled.div<SummaryProps>`
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 19px;
`;

export const SummaryContainer = styled.div`
  grid-area: Summary;

  margin-block-end: 4px;
`;
type SummaryProps = {
  theme?: ThemeType;
};
export const Summary = styled.div<SummaryProps>`
  color: #222222;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
  text-align: center;
  text-transform: uppercase;

  ${props => {
    switch (props.theme?.signUpNewsletter?.summaryFontStyle) {
      case "small":
        return css`
          font-size: 11px;
          line-height: 13px;
        `;
    }
  }}
`;

type TitleProps = {
  theme?: ThemeType;
};

export const Title = styled.div<TitleProps>`
  color: #000000;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 23px;

  ${props => {
    switch (props.theme?.signUpNewsletter?.titleFontStyle) {
      case "italic-large":
        return css`
          font-weight: 300;
          font-size: 21px;
          font-style: italic;
          line-height: 27px;
        `;
      case "large":
        return css`
          font-size: 21px;
          line-height: 27px;
        `;
      case "small":
        return css`
          font-size: 15px;
          line-height: 19px;
        `;
    }
  }}
`;
export const TitleContainer = styled.div`
  grid-area: Title;

  margin-block-end: 8px;
`;

export const ActionContainer = styled.div`
  grid-area: Action;

  margin-block-end: 10px;
`;

export const TermAndConditionLink = styled.a`
  margin-block: 0;
  margin-inline: 2px;
`;
export const TermAndConditionContainer = styled.div`
  grid-area: TermAndCondition;

  color: #999999;
  font-size: 10px;
  font-family: ${fontRoboto};
  line-height: 11px;

  ${TermAndConditionLink} {
    color: #999999;
    text-decoration: underline;
  }
`;

export const SummaryLine = styled.div`
  grid-area: SummaryLine;

  inline-size: 60px;
  block-size: 1px;
  margin-block-end: 16px;

  background-color: #001246;
`;

type ContainerProps = {
  theme?: ThemeType;
};
export const Container = styled.div<ContainerProps>`
  display: grid;
  grid-template-areas:
    "SummaryLine"
    "Summary"
    "Title"
    "Description"
    "Agreement"
    "Action"
    "TermAndCondition";
  grid-template-rows: repeat(7, minmax(0, min-content));
  justify-items: center;

  color: #ffffff;
  text-align: center;

  ${mediaTheme.breakpoints.up("tablet")} {
    ${props =>
      props.theme?.orientation === "landscape"
        ? css`
            grid-template-areas:
              "SummaryLine Action"
              "Summary Action"
              "Title Action"
              "Description Action"
              "Agreement TermAndCondition";
            grid-template-rows: repeat(5, minmax(0, min-content));
            justify-items: center;

            text-align: center;
            column-gap: 20px;
          `
        : css`
            grid-template-areas:
              "SummaryLine"
              "Summary"
              "Title"
              "Description"
              "Agreement"
              "Action"
              "TermAndCondition";
            justify-items: center;

            text-align: center;
          `}
  }
`;
